<article class="sign-up-form-wrapper">
  <form [formGroup]="signUpForm" class="sign-up-form" *ngIf="!activateSmsValidationForm">

    <app-form-divider class="d-md-none d-lg-none d-xl-none" [text]="'Regístrate con'" [textClass]="'sign-up'" *ngIf="countryConfig.singUpFormComponent.divider"></app-form-divider>


    <section class="social-network-button-wrapper" *ngIf="countryConfig.singUpFormComponent.socialIcons && formComplete">
      <app-button
        *ngIf="authActiveConfig?.facebook"
        class="signup-app-button"
        [buttonId]="idPrefix + 'sign-up-facebook'"
        [customClasses]="'facebook social full-width'"
        [title]="'Facebook'"
        [isFacebook]="true"
        [isLoading]="isLoading.facebook"
        (click)="facebook()"
      ></app-button>
      <app-button
        *ngIf="authActiveConfig?.google"
        class="signup-app-button"
        [buttonId]="idPrefix + 'sign-up-google'"
        [customClasses]="'google social full-width'"
        [title]="'Google'"
        [isGoogle]="true"
        [isLoading]="isLoading.google"
        (click)="google()"
      ></app-button>
      <app-button
        *ngIf="authActiveConfig?.apple"
        class="signup-app-button"
        [buttonId]="idPrefix + 'login-apple'"
        [customClasses]="'apple social full-width'"
        [isLoading]="isLoading.apple"
        [title]="'Continuar con Apple'"
        [isApple]="true"
        (click)="apple()"
      >
      </app-button>
    </section>

    <app-form-divider
      *ngIf="showDivider()"
      [text]="'ó'"
    ></app-form-divider>

    <section class="full-name" [class.responseMobileVzla]="countryConfig.getService">
      <div class="form-group name">
        <input [id]="idPrefix + 'sign-up-name'" type="text" class="form-control" aria-describedby="Nombre" placeholder="Nombre" [maxlength]="formConfig.name" formControlName="firstName">

        <small [id]="idPrefix + 'sign-up-name-error'" class="text-danger" *ngIf="error.firstName">
          {{ error.firstName }}
        </small>
      </div>

      <div class="form-group lastname">
        <input [id]="idPrefix + 'sign-up-last-name'" type="text" class="form-control" aria-describedby="lastName" placeholder="Apellido" [maxlength]="formConfig.name" formControlName="lastName">

        <small [id]="idPrefix + 'sign-up-last-name-error'" class="text-danger" *ngIf="error.lastName">
          {{ error.lastName }}
        </small>
      </div>
    </section>

    <section class="form-group">
      <input [id]="idPrefix + 'sign-up-email'" type="email" class="form-control" aria-describedby="Email" placeholder="Correo electrónico" [maxlength]="formConfig.email" formControlName="email">

      <small [id]="idPrefix + 'sign-up-email-error'" class="text-danger" *ngIf="error.email">
        {{ error.email }}
      </small>
    </section>

    <section class="passwords" formGroupName="passwords" [class.responseMobileVzla]="countryConfig.getService" *ngIf="!isSocialNetwork">
      <div class="form-group password-one">
        <input (paste)="paste($event)" [id]="idPrefix + 'sign-up-password'" [type]="inputPass ? 'password' : 'text'" class="form-control" aria-describedby="password" placeholder="Contraseña" [minlength]="formConfig.minPassword.toString()" [maxlength]="formConfig.maxPassword" formControlName="password">

        <img class="img-show-pass" (click)="inputPass = !inputPass" src="assets/svg/{{inputPass ? 'not-visibility' : 'eyes_login'}}.svg" alt="Contraseña">
        <small [id]="idPrefix + 'sign-up-password-error'" class="text-danger" *ngIf="error.password">
          {{ error.password }}
        </small>
      </div>

      <div class="form-group password-two">
        <input (paste)="paste($event)" [id]="idPrefix + 'sign-up-confirm-password'" type="password" class="form-control" aria-describedby="confirmPassword" placeholder="Confirme su contraseña" [minlength]="formConfig.minPassword.toString()" [maxlength]="formConfig.maxPassword" formControlName="confirmPassword">
        <small [id]="idPrefix + 'sign-up-confirm-password-error'" class="text-danger" *ngIf="error.confirmPassword">
          {{ error.confirmPassword }}
        </small>
      </div>
    </section>

    <section class="form-group">
      <select class="form-control" *ngIf="countryConfig.singUpFormComponent.documentTypeOption" [id]="idPrefix + 'sign-up-document-type'" name="documentTypeId" aria-describedby="documentTypeId" formControlName="documentTypeId">
          <option *ngFor="let documentType of documentTypes" [ngValue]="documentType.documentTypeId">
            {{ documentType.description }}
          </option>
        </select>
    </section>      

    <section class="form-group">
      <input [id]="idPrefix + 'sign-up-document-number'" type="text" class="form-control" aria-describedby="documentNumber" placeholder="Número de documento" [maxlength]="formConfig.documentNumber" minlength="1" formControlName="documentNumber">
      <small [id]="idPrefix + 'sign-up-document-number-error'" class="text-danger" *ngIf="error.documentNumber">
        {{ error.documentNumber }}
      </small>
    </section>

    <section class="full-phone" [class.responseMobileVzla]="countryConfig.getService">
      <div class="form-group country-select">
        <app-country-select [idPrefix]="idPrefix + 'sign-up'" [placeholder]="'Seleccione un prefijo de país'" (selectedCountry)="onSelectedCountry($event)"></app-country-select>
        <small [id]="idPrefix + 'sign-up-country-error'" class="text-danger" *ngIf="error.country">
          {{ error.country }}
        </small>
      </div>

      <div class="form-group phone-code" *ngIf="countryConfig.singUpFormComponent.phoneCodeOption">
        <app-phone-code [idPrefix]="idPrefix + 'sign-up'" formControlName="phoneCode" #phoneCode name="phoneCode" (changeValue)="onSelectedPhoneCode($event)">
        </app-phone-code>
      </div>

      <div class="form-group phone">
        <input [id]="idPrefix + 'sign-up-phone'" type="text" class="form-control" aria-describedby="Teléfono" placeholder="Número de teléfono" [maxlength]="phoneLength" [minlength]="phoneLength" #phoneNumber formControlName="phone" (keyup.enter)="validateCustomer()">
        <small [id]="idPrefix + 'sign-up-phone-error'" class="text-danger" *ngIf="error.phone">
        </small>
      </div>
    </section>

    <section class="form-group gender">
      <div class="radio radio-success d-flex justify-content-around align-items-center">
        <span class="radio-option">
        <input [id]="idPrefix + 'sign-up-female'" formControlName="gender" type="radio" checked="checked" value="female" name="gender">
        <label class="label" [for]="idPrefix + 'sign-up-female'">Mujer</label>
      </span>
        <span class="radio-option">
        <input [id]="idPrefix + 'sign-up-male'" formControlName="gender" type="radio" value="male" name="gender">
        <label class="label" [for]="idPrefix + 'sign-up-male'">Hombre</label>
      </span>
      </div>
    </section>

    <section class="terms-link">
        <label class="label-terms" [for]="idPrefix + 'terms-and-conditions'">
          <input [id]="idPrefix + 'terms-and-conditions'" (change)="termsCheck($event)" formControlName="terms" type="checkbox" name="terms">
          <small>
            Acepto y autorizo<a target="_blank" href="politicas/terminos-y-condiciones"> términos y condiciones</a> las <a target="_blank" href="politicas/politicas-de-privacidad">políticas de privacidad</a> y <a target="_blank" href="politicas/habeas-data">política de tratamiento de datos personales</a>
          de Farmatodo.</small>
        </label>
    </section>
    <app-error-message [error]="errorObj" [idPrefix]="idPrefix + 'sign-up-'"></app-error-message>

    <section class="">
      <app-button class="signup-app-button" [buttonId]="idPrefix + 'sign-up-validate-customer'" [title]="'Registrarme'" [isDisabled]="!signUpForm.valid" [customClasses]="'main full-width sign-up-button'" [isLoading]="isLoading.email" (click)="validateCustomer()"></app-button>

      <app-button *ngIf="formComplete" class="signup-app-button" [buttonId]="idPrefix + 'sign-up-open-login'" [title]="'Iniciar sesión'" [customClasses]="'transparent full-width bold'" (click)="openLoginForm()"></app-button>
    </section>

  </form>

  <app-validate-phone-form [idPrefix]="idPrefix + 'sign-up-'" (closeActivation)="closeActivation($event)" *ngIf="!countryConfig.singUpFormComponent.directSingUp  && activateSmsValidationForm" [phone]="phone" [isSignUpForm]="true" (validated)="signUp()"></app-validate-phone-form>
  <app-modal-ok-singup [modalOkSingUp]="modalOkSingUp" ></app-modal-ok-singup>
  <app-overlay [isLoading]="activateSmsValidationForm && isLoading.email" ></app-overlay>
</article>
